/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_No_PaymentsInputs */

const en_settings_billing_no_payments = /** @type {(inputs: Settings_Billing_No_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No payments yet`)
};

/**
* | output |
* | --- |
* | "No payments yet" |
*
* @param {Settings_Billing_No_PaymentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_no_payments = /** @type {((inputs?: Settings_Billing_No_PaymentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_No_PaymentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_no_payments(inputs)
});
export { settings_billing_no_payments as "settings.billing.no_payments" }